import getFilterableContent from './fetch';
import { filterableEventsTemplate } from './template';
import { setParams, getParams } from './params.js';
import setExistingInputs from './inputs';

/**
 * Initiate filterable content blocks logic.
 */
const initFilterableContent = () => {
	// Get all filterable content blocks.
	const filterableContentBlock = document.querySelectorAll('.nstg-block-filterable-events');

	// Loop through each block and apply logic only to that block.
	filterableContentBlock.forEach((block) => {
		const contentContainer = block.querySelector('.em-filterable-content__listings');
		const inputs = block.querySelectorAll('.em-filterable-content__filters select, .filter-search');
		const search = block.querySelector('.search');
		const view = block.querySelectorAll('[name="view"]');

		// Process filters and search values.
		const getFilteredContent = () => {
			setParams(inputs, block.id, true);
			getFilterableContent(contentContainer, getParams(block.id, true), filterableEventsTemplate);
		};

		// Loop through inputs and set event handlers.
		inputs.forEach((input) => {
			search.onclick = () => {
				getFilteredContent();
			};

			if (input.nodeName === 'SELECT') {
				input.onchange = () => {
					getFilteredContent();
				};
				return;
			}

			input.onkeyup = (e) => {
				if (e.code === 'Enter') {
					getFilteredContent();
				}
			};
		});

		view.forEach((input) => {
			input.onchange = () => {
				contentContainer.classList.remove('em-filterable-content__listings--view-list', 'em-grid-1', 'em-filterable-content__listings--view-grid', 'em-grid-3-equalHeight');
				if (input.value === 'grid') {
					contentContainer.classList.add('em-filterable-content__listings--view-grid', 'em-grid-3-equalHeight');
				}
				if (input.value === 'list') {
					contentContainer.classList.add('em-filterable-content__listings--view-list', 'em-grid-1');
				}
			};
		});

		// Set existing values for inputs.
		setExistingInputs(block);

		// Get initial list of posts and output.
		getFilterableContent(contentContainer, getParams(block.id), filterableEventsTemplate);
	});
};

initFilterableContent();
